import { activeInspectorTypes as types } from '@/constants/inspectorViewTypes';
// import isEmpty from 'lodash/isEmpty';

const formatMulti = (type, tabletKey) => value => ({ type, tabletKey, ids: value });

/*
    Функция для формирования multiObject состояния
*/
function formatMultiObject(previousState, payload) {
    const { type, id, action, tabletKey } = payload;

    const formatMultiByType = formatMulti(type, tabletKey);

    if (!previousState || previousState.type !== type || !action) {
        return formatMultiByType([id]);
    }

    if (previousState.ids.includes(id) && action) {
        const filteredIds = previousState.ids.filter(curveId => curveId !== id);
        return formatMultiByType(filteredIds);
    }

    return formatMultiByType([...previousState.ids, id]);
}

/*
    Выбор активного элемента на планшете.

    * object (единичный выбор):
        - default value: null
        - selected value: { type, id: Number | String }

    * multiObject (выбор нескольких объектов на планшете):
        - default value: null
        - selected value: { type, ids: Number[] | String[] }

    Подключение модели происходит через hoc-s:
    - withTabletMultiObject
    - withTabletObject

    Выбор hoc-a зависит от типа выбора элемента.
*/

export const tabletObjectsModel = {
    state: {
        object: null,
        multiObject: null,
    },
    reducers: {
        setObject(state, payload) {
            const multiObject = state.multiObject ? { multiObject: null } : {};
            return { ...state, object: payload, ...multiObject };
        },
        setMultiObject(state, payload) {
            const object = state.object ? { object: null } : {};

            return { ...state, multiObject: formatMultiObject(state.multiObject, payload), ...object };
        },
        reset(state) {
            return { ...state, object: null, multiObject: null };
        },
    },
    effects: dispatch => ({
        setMultiObjectEffect(payload, rootState) {
            const { mode } = rootState.displayTabletMode;
            if (mode !== 'DEFAULT') return;

            const { activeItemKey } = rootState.lists;
            if (payload.tabletKey !== activeItemKey) return;

            this.setMultiObject(payload);
            dispatch.inspector.setInspectorInfoEffect({ activeState: 'multiObject' });
        },
        setObjectEffect(payload, rootState) {
            const { mode } = rootState.displayTabletMode;
            

            if (mode !== 'DEFAULT') return;

            const { activeItemKey } = rootState.lists;

            if (payload.tabletKey !== activeItemKey) return;

            this.setObject(payload);

            // dispatch.runner.setIsActiveRunner(false);

            dispatch.inspector.setInspectorInfoEffect({ activeState: 'object' });
        },
        resetTabletActiveObject(tabletKey, rootState) {
            const { mode } = rootState.displayTabletMode;
            if (mode !== 'DEFAULT') return;

            const { activeItemKey } = rootState.lists;
            if (tabletKey !== activeItemKey && tabletKey) return;

            this.reset();
            // dispatch.runner.setIsActiveRunner(true);
            dispatch.inspector.resetData({
                type: types.DEFAULT,
                data: rootState.inspector.filteredCurveData,
                title: rootState.inspector.wellTitle,
            });
        },
    }),
};
